import { render } from "./EditLab.vue?vue&type=template&id=35c84058"
import script from "./EditLab.vue?vue&type=script&lang=js"
export * from "./EditLab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__